export function getTimeElapsed(dateStr: string) {
  const today = new Date();
  const givenDate = new Date(dateStr);
  const diffTime = Math.abs(today.getTime() - givenDate.getTime());
  const diffDays = Math.round(diffTime / (1000 * 60 * 60 * 24));

  if (diffDays === 0) {
    return 'today';
  }
  if (diffDays === 1) {
    return 'yesterday';
  }
  if (diffDays < 31) {
    return `${diffDays} days ago`;
  }
  if (diffDays < 366) {
    const diffMonths = Math.round(diffDays / 30);
    return `${diffMonths} month${diffMonths > 1 ? 's' : ''} ago`;
  }
  const diffYears = Math.round(diffDays / 365);
  return `${diffYears} year${diffYears > 1 ? 's' : ''} ago`;
}

export default getTimeElapsed;
